import { useState } from 'react';
import type { WebUrl } from '../types/webUrl.types';

interface WebUrlModalState {
  webUrl: WebUrl | null;
}

export function useWebUrlActionModals() {
  const [modalState, setModalState] = useState<WebUrlModalState | null>(null);
  const [webUrlToDelete, setWebUrlToDelete] = useState<WebUrl | null>(null);

  return {
    modalState,
    webUrlToDelete,
    openCreateModal: () => setModalState({ webUrl: null }),
    openEditModal: (webUrl: WebUrl) => setModalState({ webUrl }),
    closeModal: () => setModalState(null),
    openDeleteModal: setWebUrlToDelete,
    closeDeleteModal: () => setWebUrlToDelete(null),
  };
}
